import React from 'react';
import OptionSelect from './OptionSelect.jsx';
import _Style from './_Style.scss';
import ShowIf from './ShowIf.jsx';

class Select extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data,
      value: this.props.value,
      text: this.props.text,
      keyName: this.props.keyName,
      optionOpened: false,
      textSelected: this.props.placeHolder
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      value: nextProps.value,
      text: nextProps.text,
      keyName: nextProps.keyName
    });
  }


  selectedOption(e) {
    let value = e.target.value;
    let text = e.target.text;
    this.setState({
      value: value,
      textSelected: text
    },()=> {
      this.toggleOption(this);
      this.pushData();
    })
  }

  toggleOption(e) {
    if (!this.state.optionOpened) {
      document.addEventListener('click', this.handleOutsideClick.bind(this), false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
    }

    this.setState({
      optionOpened: !this.state.optionOpened
    })
  }

  closeOption(){
    this.setState({
      optionOpened: false
    })
  }

  handleOutsideClick(e) {
    if (this.node && this.node.contains(e.target)) {
      return;
    } else if (this.node && !this.node.contains(e.target)){
      this.closeOption();
    }
  }

  pushData() {
    let data = {
      target: {
        text: this.state.textSelected,
        value: this.state.value
      }
    }
    this.props.onChange(data)
  }

  clearData() {
    this.setState({
      value: '',
      textSelected: ''
    },()=> {
      this.toggleOption(this)
      this.pushData();
    })
  }

  render() {
    return (
      <section className={this.state.optionOpened ? 'rs-wrapper rs-one-element open' : 'rs-wrapper rs-one-element'} id='node' ref={node => { this.node = node; }}>
        <div className='rs-option-selected' onClick={this.toggleOption.bind(this)}>
          <ShowIf condition={this.state.value}>
            <span className='item-selected'>{this.state.textSelected}</span>
          </ShowIf>
          <ShowIf condition={this.state.value === ''}>
            <span className='rs-place-holder'>{this.props.placeHolder}</span>
          </ShowIf>
        </div>
        <div className={this.state.optionOpened ? 'rs-wrap-options' : 'rs-wrap-options hidden'}>
          <div className='rs-children'>
            <span className='rs-label' onClick={this.clearData.bind(this)}>{this.props.placeHolder}</span>
          </div>
          <div className='wrap-option'>
            {
              this.state.data.map((item,i) => {
                return(
                  <OptionSelect key={i} text={item[this.state.text]} valueSelected={this.state.value} selectedOption={this.selectedOption.bind(this)} keyName={item[this.state.keyName]}/>
                )
              })
            }
          </div>
        </div>
      </section>
    )
  }
}

Select.defaultProps = {
  data: [],
  value: [],
  text: '',
  keyName: '',
  placeHolder: '--Chọn--',
  onChange: function () {
    console.log('Need to assign onChange method');
  }
}


export default Select;



// WEBPACK FOOTER //
// ./components/partials/select/Select.jsx